/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable import/no-unresolved */
import { ArrowRightOutlined } from '@ant-design/icons';
import { MessageDisplay } from 'components/common';
import { ProductShowcaseGrid, FeaturedProduct } from 'components/product';
import { applyFilter } from 'redux/actions/filterActions';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { SHOP } from 'constants/routes';
import {
  useDocumentTitle,
  useLatestProducts,
  useScrollTop,
  useFeaturedProducts
} from 'hooks';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SwiperCore, {
  EffectFade,
  Pagination,
  Autoplay,
  Navigation
} from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import Select from 'react-select';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import fullLogoWordmark from '../../images/logo-full.png';
import useWindowSize from '../../hooks/useWindowSize';
import { getHome } from '../../redux/actions/homeActions';
import regioni from '../../files/regioni.json';
import province from '../../files/province.json';
import npaCodes from '../../files/npa.json';
import firebase from '../../firebase/firebase';

const Home = () => {
  const { t, i18n } = useTranslation();
  useDocumentTitle(t('titleHome'));
  useScrollTop();
  const dispatch = useDispatch();
  const [width] = useWindowSize();

  let numberSlides = 3;
  let isEnabledNavigation = true;
  let isEnabledPagination = false;
  if (width <= 928) {
    numberSlides = 1;
    isEnabledNavigation = false;
    isEnabledPagination = true;
  }

  const { latestProducts, fetchLatestProducts, isLoadingLatest, errorLatest } =
    useLatestProducts(4);
  const {
    featuredProducts,
    fetchFeaturedProducts,
    isLoadingFeatured,
    errorFeatured
  } = useFeaturedProducts(12);

  const store = useSelector(
    (state) => ({
      images: state.home.images,
      ads: state.home.ads
    }),
    shallowEqual
  );

  const [isFetching, setFetching] = useState(false);

  useEffect(() => {
    if (store.images.length === 0 && store.ads.length === 0) {
      setFetching(true);
      dispatch(getHome());
      setFetching(false);
    }
  }, []);

  SwiperCore.use([Autoplay, EffectFade, Navigation, Pagination]);

  const defaultRegion = { value: '', label: t('menuFilterAnyRegion') };
  const defaultProvince = { value: '', label: t('menuFilterAnyProvince') };
  const defaultNpa = { value: '', label: t('menuFilterAnyNPA') };
  const [selectedRegion, setSelectedRegion] = useState(defaultRegion);
  const [selectedProvince, setSelectedProvince] = useState(defaultProvince);
  const [selectedNpa, setSelectedNpa] = useState(defaultNpa);
  const regionList = [defaultRegion];
  regioni.map((data) =>
    regionList.push({ value: data.nome, label: data.nome })
  );
  const [addressList, setAddressList] = useState({
    province: [defaultProvince]
  });
  function parseProvinces(region) {
    addressList.province.splice(1, addressList.province.length);
    province
      .filter((data) => data.regione === region)
      .map((data) =>
        addressList.province.push({ value: data.nome, label: data.nome })
      );
  }
  parseProvinces(selectedRegion.value);

  const npaList = [defaultNpa];
  const keys = Object.keys(npaCodes);
  keys.map((data) => npaList.push({ value: data, label: data }));

  const onRegionFilterChange = (e) => {
    setSelectedRegion(e);
    parseProvinces(e.value);
  };

  const onProvinceFilterChange = (e) => {
    setSelectedProvince(e);
  };

  const onNpaFilterChange = (e) => {
    setSelectedNpa(e);
  };

  useEffect(() => {
    parseProvinces(selectedRegion);
    setAddressList({ province: [defaultProvince] });
  }, [selectedRegion]);

  useEffect(() => {
    setSelectedProvince(addressList.province[0]);
  }, [addressList]);

  const homeFilter = () =>
    dispatch(
      applyFilter({
        region: selectedRegion.value,
        province: selectedProvince.value,
        npa: selectedNpa.value
      })
    );

  useEffect(() => {
    setSelectedRegion(defaultRegion);
    setSelectedNpa(defaultNpa);
  }, [i18n.language]);

  return (
    <main className="content">
      <div className="home">
        <div className="banner" style={{ marginBottom: '5rem' }}>
          <div className="banner-desc">
            {fullLogoWordmark && (
              <img
                alt="Uilpi"
                src={fullLogoWordmark}
                style={{ width: '260px' }}
              />
            )}
            <p>{t('bannerMessage')}</p>
            <br />
            <div className="home-selector-div">
              {firebase.clientLocation === 'Italia' && (
                <>
                  <Select
                    className="home-selector home-selector-region"
                    options={regionList}
                    value={{
                      label: selectedRegion.label,
                      value: selectedRegion.value
                    }}
                    onChange={onRegionFilterChange}
                  />
                  <Select
                    className="home-selector"
                    options={addressList.province}
                    value={{
                      label: selectedProvince.label,
                      value: selectedProvince.value
                    }}
                    onChange={onProvinceFilterChange}
                  />
                </>
              )}
              {firebase.clientLocation === 'Svizzera' && (
                <Select
                  className="home-selector"
                  options={npaList}
                  value={{
                    label: selectedNpa.label,
                    value: selectedNpa.value
                  }}
                  onChange={onNpaFilterChange}
                />
              )}
              <Link
                to={SHOP}
                onClick={homeFilter}
                className="button"
                style={{ minWidth: 'fit-content' }}
              >
                {t('bannerButton')} &nbsp;
                <ArrowRightOutlined />
              </Link>
            </div>
          </div>
          <div className="banner-img">
            <Swiper
              spaceBetween={30}
              effect="fade"
              navigation={isEnabledNavigation}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false
              }}
              pagination={{
                clickable: true
              }}
              className="mySwiper"
            >
              {!isFetching &&
                store.images.map((image) => {
                  return (
                    <SwiperSlide key={image.id}>
                      <img src={image.src} />
                    </SwiperSlide>
                  );
                })}
            </Swiper>
          </div>
        </div>
        <div className="mobile-swiper-ads">
          {!isFetching &&
            store.ads.filter((e) => e.orientation === 'Orizzontale Singola')
              .length > 0 && (
              <div className="img-ads-horizontalsingle-mobile-container">
                {(() => {
                  const ad =
                    store.ads[
                      store.ads.findIndex(
                        (x) => x.orientation === 'Orizzontale Singola'
                      )
                    ];
                  return (
                    <a href={ad.url} target="_blank" rel="noreferrer">
                      <img className="img-ads-horizontal" src={ad.src} />
                    </a>
                  );
                })()}
              </div>
            )}
        </div>
        <div className="display ads-maincontainer">
          {!isFetching &&
            store.ads.filter((e) => e.orientation === 'Orizzontale Singola')
              .length > 0 && (
              <div className="img-ads-container centered-ads-div">
                {(() => {
                  const ad =
                    store.ads[
                      store.ads.findIndex(
                        (x) => x.orientation === 'Orizzontale Singola'
                      )
                    ];
                  return (
                    <a href={ad.url} target="_blank" rel="noreferrer">
                      <img className="img-ads-horizontal-single" src={ad.src} />
                    </a>
                  );
                })()}
              </div>
            )}
        </div>
        <div className="display">
          <div className="display-header">
            <h1>{t('featuredMessage')}</h1>
          </div>
          {errorFeatured && !isLoadingFeatured ? (
            <MessageDisplay
              message={errorFeatured}
              action={fetchFeaturedProducts}
              buttonLabel={t('errorButtonRetry')}
            />
          ) : (
            <div className="banner-featured">
              <Swiper
                slidesPerView={numberSlides}
                spaceBetween={30}
                pagination={isEnabledPagination}
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false
                }}
                className="mySwiper"
              >
                {featuredProducts.map((product) => (
                  <SwiperSlide key={product.id}>
                    <FeaturedProduct product={product} />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          )}
        </div>
        <div className="mobile-swiper-ads">
          {!isFetching &&
            store.ads.filter((e) => e.orientation === 'Verticale').length >
              0 && (
              <div className="img-ads-vertical-mobile-container">
                {(() => {
                  const ad =
                    store.ads[
                      store.ads.findIndex((x) => x.orientation === 'Verticale')
                    ];
                  return (
                    <a href={ad.url} target="_blank" rel="noreferrer">
                      <img className="img-ads-vertical" src={ad.src} />
                    </a>
                  );
                })()}
              </div>
            )}
        </div>
        <div className="home-ads-division">
          <div className="display" style={{ flexBasis: '80%' }}>
            <div className="display-header">
              <h1>{t('lastAddedMessage')}</h1>
              <Link to={SHOP}>{t('lastAddedButton')}</Link>
            </div>
            {errorLatest && !isLoadingLatest ? (
              <MessageDisplay
                message={errorLatest}
                action={fetchLatestProducts}
                buttonLabel={t('errorButtonRetry')}
              />
            ) : (
              <ProductShowcaseGrid
                products={latestProducts}
                skeletonCount={4}
              />
            )}
          </div>
          <div className="display">
            {!isFetching &&
              store.ads.filter((e) => e.orientation === 'Verticale').length >
                0 && (
                <div className="img-ads-container">
                  {(() => {
                    const ad =
                      store.ads[
                        store.ads.findIndex(
                          (x) => x.orientation === 'Verticale'
                        )
                      ];
                    return (
                      <a href={ad.url} target="_blank" rel="noreferrer">
                        <img className="img-ads-vertical" src={ad.src} />
                      </a>
                    );
                  })()}
                </div>
              )}
          </div>
        </div>
        <div className="mobile-swiper-ads">
          <Swiper
            spaceBetween={30}
            effect="fade"
            allowTouchMove={false}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false
            }}
            className="mySwiper mobile-swiper-ads"
          >
            {!isFetching &&
              store.ads
                .filter((e) => e.orientation === 'Orizzontale')
                .map((ad) => {
                  return (
                    <SwiperSlide key={ad.id}>
                      <a href={ad.url} target="_blank" rel="noreferrer">
                        <img src={ad.src} style={{ width: '100%' }} />
                      </a>
                    </SwiperSlide>
                  );
                })}
          </Swiper>
        </div>
        <div className="display ads-maincontainer">
          {!isFetching &&
            store.ads.filter((e) => e.orientation === 'Orizzontale').length >
              0 &&
            store.ads
              .filter((ad) => ad.orientation === 'Orizzontale')
              .map((ad, index) => {
                if (index < 2) {
                  return (
                    <div key={ad.id} className="img-ads-container">
                      <a href={ad.url} target="_blank" rel="noreferrer">
                        <img className="img-ads-horizontal" src={ad.src} />
                      </a>
                    </div>
                  );
                }
                return null;
              })}
        </div>
      </div>
    </main>
  );
};

export default Home;
